import React, { useState, useEffect } from "react";
import { Footer } from "./components/layout/Footer";
import { HeroSection } from "./components/sections/HeroSection";
import { ManufacturingSection } from "./components/sections/ManufacturingSection";
import { ComboDealsSection } from "./components/sections/ComboDealsSection";
import { Hook2Section } from "./components/sections/Hook2Section";
import { OurTeamSection } from "./components/sections/OurTeamSection";
import { LeadFormModal } from "./components/ui/LeadFormModal";
import { WhatsAppButton } from "./components/ui/WhatsAppButton";
import { mockContent } from "./data/mockData";
import {
  initAnalytics,
  trackFacebookEvent,
  trackGA4Event,
} from "./services/analytics";

function App() {
  const content = mockContent;

  // Initialize analytics on mount
  useEffect(() => {
    initAnalytics();
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<string | undefined>();

  const openModal = (packageName?: string) => {
    // Track modal open as InitiateCheckout (shows purchase intent)
    trackFacebookEvent("InitiateCheckout", {
      content_name: packageName || "General Inquiry",
      content_category: packageName ? "Combo Deal" : "General",
    });

    trackGA4Event({
      eventName: "begin_checkout",
      eventParams: {
        item_name: packageName || "General Inquiry",
      },
    });

    setSelectedPackage(packageName);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPackage(undefined);
  };

  return (
    <div className="min-h-screen bg-black" style={{ padding: "5px" }}>
      {/* Main Content */}
      <main className="flex flex-col gap-16">
        {/* Hero Section */}
        <HeroSection
          content={content.heroSection}
          onCtaClick={() => openModal()}
        />

        {/* Combo Deals Section */}
        <ComboDealsSection
          heading={content.comboDealsSection.heading}
          combos={content.comboDealsSection.combos}
          ctaText={content.comboDealsSection.ctaText}
          onCtaClick={(comboTitle) => openModal(comboTitle)}
        />

        {/* Hook 2 Section - Featured Subjects */}
        <Hook2Section
          heading={content.hook2Section.heading}
          subheading={content.hook2Section.subheading}
          productImages={content.hook2Section.productImages}
          ctaText={content.hook2Section.ctaText}
          onCtaClick={() => openModal()}
        />

        {/* In-House Manufacturing Section */}
        <ManufacturingSection
          heading={content.manufacturingSection.heading}
          summary={content.manufacturingSection.summary}
          fullText={content.manufacturingSection.fullText}
          image={content.manufacturingSection.image}
        />

        {/* Our Team Section */}
        <OurTeamSection
          heading={content.ourTeamSection.heading}
          summary={content.ourTeamSection.summary}
          fullText={content.ourTeamSection.fullText}
          images={content.ourTeamSection.images}
        />
      </main>

      {/* Footer */}
      <Footer
        privacyPolicyUrl={content.privacyPolicyUrl}
        termsUrl={content.termsUrl}
      />

      {/* Lead Form Modal */}
      <LeadFormModal
        isOpen={isModalOpen}
        onClose={closeModal}
        packageName={selectedPackage}
      />

      {/* WhatsApp Floating Button */}
      <WhatsAppButton
        phoneNumber={content.whatsapp.phoneNumber}
        message={content.whatsapp.message}
      />
    </div>
  );
}

export default App;
